module.exports = __webpack_public_path__ + "img/22.101adc21.png";